/* pdp-apps-guard.js — colapsa el wrapper de las apps de terceros (SMPS Q&A,
   Areviews, Gropulse Google Reviews) SOLO cuando queda confirmado que no
   hay contenido real, sin ocultar nunca contenido que llegue tarde.

   Por qué ResizeObserver y no MutationObserver: medido en vivo con
   Playwright en dos productos reales -- estas 3 apps NO insertan ni quitan
   nodos del DOM tras el render inicial (su markup completo, incluidos
   <style>/<script> internos, ya está en el HTML servido desde el primer
   momento). Lo que cambia con el tiempo es la ALTURA visual del wrapper ya
   existente, una vez la app monta su UI (a veces disparado por scroll-into-
   view). Un MutationObserver no vería ese cambio (mismo número de hijos
   antes/después); ResizeObserver sí, porque mide tamaño, no estructura.

   Por qué IntersectionObserver además: si se empezara a contar "vacío" desde
   el primer instante de carga de la página, una app que difiere su render
   hasta que el usuario se acerca haciendo scroll (comportamiento observado)
   se marcaría vacía antes de tener oportunidad real de cargar. Por eso el
   cronómetro de confirmación solo arranca cuando el wrapper está a punto de
   entrar en viewport.

   No se toca ningún script interno de las apps: solo se mide y, si aplica,
   se le agrega una clase CSS al wrapper del TEMA (#shopify-section-...) que
   ya existe siempre. Ambos observers se desconectan en cuanto el estado
   queda resuelto (contenido real u vacío confirmado) -- no quedan activos
   de forma permanente. */
(function () {
  'use strict';
  if (window.__pdpAppsGuardInit) return;
  window.__pdpAppsGuardInit = true;

  var IDS = ['17718273134f8bb09a', '1770120004fe7957c2', 'apps_JDRQdE'];
  var EMPTY_THRESHOLD_PX = 8;
  var MAX_WAIT_MS = 9000;

  function watch(sectionId) {
    var wrapper = document.querySelector('[id$="__' + sectionId + '"]');
    if (!wrapper || wrapper.__pdpGuarded) return;
    wrapper.__pdpGuarded = true;

    var settled = false;
    var ro = null;
    var io = null;
    var fallbackTimer = null;

    function contentHeight() {
      return wrapper.getBoundingClientRect().height;
    }

    function finish(isEmpty) {
      if (settled) return;
      settled = true;
      if (ro) ro.disconnect();
      if (io) io.disconnect();
      if (fallbackTimer) clearTimeout(fallbackTimer);
      if (isEmpty) wrapper.classList.add('pdp-app-empty');
    }

    function startCountdown() {
      if (fallbackTimer) return;
      fallbackTimer = setTimeout(function () {
        finish(contentHeight() <= EMPTY_THRESHOLD_PX);
      }, MAX_WAIT_MS);
    }

    if (contentHeight() > EMPTY_THRESHOLD_PX) {
      finish(false);
      return;
    }

    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(function () {
        if (contentHeight() > EMPTY_THRESHOLD_PX) finish(false);
      });
      ro.observe(wrapper);
    }

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) startCountdown();
      }, { rootMargin: '600px 0px' });
      io.observe(wrapper);
    } else {
      startCountdown();
    }
  }

  function run() {
    IDS.forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
